import { log } from '@/log'

export function triggerExternalLogin(
  brand: string, options: { redirectEndpoint: string, brandContext: string | null, }
): void {
  const endpoint = getExternalSite(brand)

  if (!endpoint) {
    log.error(`External login site is not set for appId: ${brand}`)

    return
  }

  const url = addQuery(endpoint, options)

  // Redirect
  location.replace(url)
}

export function isExternalLoginEnabled(): boolean {
  return process.env.EXTERNAL_LOGIN_ENABLED === 'true'
}

export function shouldDisplayForTargetBrand(brandName: string): boolean {
  /**
   * 外部ログインボタン表示用の環境変数を用意しても、外部ログイン用URLを設定せずに表示許可することは有り得ないため、
   * 「外部ログインボタンを表示する＝外部ログイン用URLが設定されている」事として外部ログイン用URLを表示判定に利用する。
   */
  return getExternalSite(brandName) !== null
}

export function externalButtonDisplayOrder(): string[] {
  const order = process.env.EXTERNAL_LOGIN_BUTTON_DISPLAY_ORDER || ''

  return order.split(',')
}

function getExternalSite(brand: string): string |  null {
  switch (brand) {
    case 'micoameri':
      return process.env.EXTERNAL_LOGIN_SITE_MICOAMERI || null
    case 'michellmacaron':
      return process.env.EXTERNAL_LOGIN_SITE_MICHELLMACARON || null
    case 'rady':
      return process.env.EXTERNAL_LOGIN_SITE_RADY || null
    default:
      return null
  }
}

function addQuery(
  endpoint: string | undefined,
  query: {
    redirectEndpoint: string,
    brandContext: string | null,
  }
): string {
  const { redirectEndpoint, brandContext } = query

  const redirectUri = encodeURIComponent(
    brandContext ? `${redirectEndpoint}?brand=${brandContext}` : redirectEndpoint
  )

  return `${endpoint}?redirect_uri=${redirectUri}`
}
